import { Group } from '@mantine/core';
import { ColorSchemeToggle } from '~portal/components/ColorSchemeToggle';
import { Cmp } from '~portal/lib';

/**
 * @desc The scheme control, as one compact row directly above the account block. Not in the Figma
 * file — kept visible by operator decision so the setting does not move behind a menu
 * (docs/figma-deviations.md). The admin cog that used to sit beside it is now the "Admin" item at
 * the foot of the section items (add-ario-identity-and-authoring-round-3 D4); the chat surfaces
 * keep the cog, because the standalone build renders those too.
 */
export const NavSettings: Cmp = function () {
  return (
    <Group gap="xs" wrap="nowrap" px="xs">
      <ColorSchemeToggle />
    </Group>
  );
};
